export default [
    {
        path: '/teacher-managers',
        name: 'teacher-managers',
        component: () => import('./pages/Index'),
        meta: {
            title: 'Gestores',
            icon: 'mdi-account-tie',
            breadcrumbs: [
                { text: 'Gestores', disabled: true }
            ]
        }
    }
]
